import React from "react";
import { useFormContext } from "react-hook-form";

import { CustomCalendar } from "components/CustomCalendar/CustomCalendar";
import { FormField } from "components/form/FormField/FormField";

import style from "../AddVaccineForm.module.css";

const getNestedError = (errors, path) => {
  const parts = path.split(".");
  return parts.reduce((acc, part) => {
    if (!acc) return undefined;
    return acc[part];
  }, errors);
};

export const DateField = ({
  name,
  label,
  placeholder = "Select date",
  disabled = false,
  minDate,
  maxDate,
  helperText,
  required = false,
  ariaRequired = false,
  onBlur,
}) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const value = watch(name);
  const fieldError = getNestedError(errors, name);

  // CustomCalendar has no native blur event - a value being set (picked or cleared) is this
  // field's equivalent of "the user left it with this value", so that's when `onBlur` fires.
  const handleChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      setValue(name, `${year}-${month}-${day}`, {
        shouldDirty: true,
        shouldValidate: true,
      });
    } else {
      setValue(name, "", { shouldDirty: true, shouldValidate: true });
    }
    onBlur?.();
  };

  return (
    <FormField name={name}>
      <label className={style.pregnancyFormLabel}>
        {label}
        {required ? " *" : ""}
      </label>
      <div
        {...(required || ariaRequired ? { "aria-required": "true" } : undefined)}
      >
        <CustomCalendar
          value={value && value !== "" ? value : null}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          error={!!fieldError}
        />
      </div>
      {helperText && <p className={style.reactionFieldLabelText}>{helperText}</p>}
    </FormField>
  );
};
